import { derived, writable } from 'svelte/store';
import { addItemToState } from './addItemToState';
import { getDiscountAmount } from './getDiscountAmount';
import { getItemsCount } from './getItemsCount';
import { getTotalPrice } from './getTotalPrice';
import { removeSkuFromState } from './removeSkuFromState';
import { setSkuQuantityInState } from './setSkuQuantityInState';
export function isPercentDiscount(discount) {
    return 'discountPercent' in discount;
}
export function isAmountDiscount(discount) {
    return 'discountAmount' in discount;
}
function defaultState() {
    return {
        items: [],
        discount: undefined
    };
}
export function createCartStore(initialState = defaultState()) {
    const store = writable(initialState);
    const { update, set, subscribe } = store;
    const reset = () => set(defaultState());
    const removeSku = (sku) => update(removeSkuFromState(sku));
    const setSkuQuantity = (sku, quantity) => update(setSkuQuantityInState(sku, quantity));
    const addItem = (item) => update(addItemToState(item));
    const itemsCount = () => derived(store, getItemsCount);
    const totalPrice = () => derived(store, getTotalPrice);
    const discountAmount = () => derived(store, getDiscountAmount);
    return {
        subscribe,
        update,
        set,
        reset,
        addItem,
        removeSku,
        setSkuQuantity,
        itemsCount,
        totalPrice,
        discountAmount
    };
}
